// lbl.profile
export const profile = {
    whopper_level: 'Whopper {0} Level',
    have_crowns: 'You have {0} crowns',
    point_description: 'Get {0} more crowns by {1} to {2} level',
    point_history: 'Point history',
    benefits: 'Tier Benefits',
    facebook: 'Facebook',
    connect: 'Connected',
    address: 'Address',
    credit: 'Credit/ debit card',
    tax_invoice: 'Tax invoice',
    my_favorite: 'My favorite',
    change_mobile_pin: 'Change mobile pin',
    language: 'Language',
    en: 'EN',
    th: 'TH',
    stores: 'Stores',
    contact_us: 'Contact us',
    term_and_condition: 'Term and condition',
    privacy_statement: 'Privacy statement',
    fresh_taste: 'Fresh Taste',
    catering: 'Catering',
    made_to_order: 'Made to Order',
    promotion: 'Promotion',
    sign_out: 'Sign out',
    my_coupon: 'My Coupon',
    register_to_privilege: 'Register to get privilege',

    firstname: {
        name: 'Firstname',
        placeholder: 'Firstname',
        required: 'Please enter firstname',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: 'Lastname',
        required: 'Please enter lastname',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'Contact number',
        placeholder: 'Contact number',
        required: 'Contact number',
        too_short: 'Contact number must be {0} digits',
        invalid: 'Incorrect contact number format',
    },
    email: {
        name: 'Email',
        placeholder: 'Email',
        required: 'Please enter email address',
        too_short: '',
        invalid: 'Incorrect email format',
    },
    idCard: {
        name: 'ID card',
        placeholder: 'ID card',
        required: 'Pleae enter ID card',
        too_short: 'Pleae enter ID card 13 digits',
        invalid: 'ID card invalid',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: 'Please enter passwrod',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'Gender',
        placeholder: 'Please select',
        required: 'Please select gender',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'Birthdate',
        placeholder: '',
        required: 'Please select birthdate',
        too_short: '',
        invalid: 'Birthdate invalid',
        date: {
            name: '',
            placeholder: 'Day',
            required: ' '
        },
        month: {
            name: '',
            placeholder: 'Month',
            required: ' '
        },
        year: {
            name: '',
            placeholder: 'Year',
            required: ' '
        },
    },
    zipcode: {
        name: 'Zipcode',
        placeholder: 'Zipcode',
        required: 'Please enter zipcode',
        too_short: 'Zipcode must be {0} digits',
        invalid: 'Invalid zipcode',
    },
    subdistrict: {
        name: 'Sub district',
        placeholder: 'Please selece sub-district',
        required: 'Please selece sub-district',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'District',
        placeholder: 'Please selece district',
        required: 'Please selece district',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'Province',
        placeholder: 'Please selece province',
        required: 'Please selece province',
        too_short: '',
        invalid: '',
    },

    male: "Male",
    female: "Female",
    notspecified: "Notspecified",

    popup_logout: {
        msg: 'Are you sure you want to sign out?',
        confirm: 'Confirm'
    },

    i_interested: 'I am interested in and would like to receive information about products, services, free, gifts, discounts, promotions and other relevant activities from Burger King and affiliated companies and relevant brands',
    delete_account: 'Delete account',
    modal_delete: {
        msg: 'Are you sure you want to delete your account? You will not able to signin and all your reward points will be lost.',
        btn: 'Confirm'
    },
    update: 'Update',
};
